import { HttpErrorResponse } from '@angular/common/http';
import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { INotApplicableCriteria } from 'src/app/shared/models/not-applicable-criteria.model';
import { NOT_APPLICABLE_CRITERIA_API_ACTIONS } from '../actions/not-applicable-criteria.actions';

export const NOT_APPLICABLE_CRITERIA_STATE_KEY = 'not-applicable-criteria';

export interface INotApplicableCriteriaState {
  data: INotApplicableCriteria[];
  loading: boolean;
  error: HttpErrorResponse | null;
}

export const notApplicableCriteriaInitialState: INotApplicableCriteriaState = {
  data: [],
  loading: false,
  error: null,
};

const reducer: ActionReducer<INotApplicableCriteriaState> = createReducer<INotApplicableCriteriaState>(
  notApplicableCriteriaInitialState,
  on(NOT_APPLICABLE_CRITERIA_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
  })),
  on(NOT_APPLICABLE_CRITERIA_API_ACTIONS.success, (state, { data }) => ({
    ...state,
    loading: false,
    data,
  })),
  on(NOT_APPLICABLE_CRITERIA_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const NOT_APPLICABLE_CRITERIA_REDUCER = createFeature({
  name: NOT_APPLICABLE_CRITERIA_STATE_KEY,
  reducer,
});
